export enum OrderType {
    mPurse = 1,
    Coupon = 2,
    ePurse = 3,
    Penalty = 4
}
